import { AssetGroup } from '@play-co/timestep-core';
import { StackView, ViewOpts } from '@play-co/timestep-core/ui';
import { hideLoading, showLoading } from 'src/state/ui';
import StateObserver from 'src/StateObserver';
import { TransitioningScene } from '../logic/SceneManager';

export type ScreenOpts = Omit<ViewOpts, 'infinite' | 'canHandleEvents'>;

export default abstract class Screen<
  Args extends [Object | void | string] = [void],
> extends StackView {
  private _currentScene: TransitioningScene | undefined = undefined;

  constructor(opts?: ScreenOpts) {
    super({
      ...opts,
      infinite: true,
      canHandleEvents: false,
    });
  }

  public get currentScene() {
    return this._currentScene;
  }

  public showScreen(..._: Args) {}

  /**
   * Execute preload logic for screen
   */
  public async preloadScreen(..._: Args) {}

  /**
   * Override this if you want to load extra assets for scene
   */
  protected getAssetsGroup(): AssetGroup | null {
    return null;
  }

  /**
   * Load required assets
   */
  public async loadAssets() {
    const assetsGroup = this.getAssetsGroup();
    if (!assetsGroup || assetsGroup.isLoaded()) return;

    StateObserver.dispatch(showLoading());
    await assetsGroup.load();
    StateObserver.dispatch(hideLoading());
  }

  /**
   * If you need to wait for screen hide:
   *
   * @example
   *
   * const screen = await screenManager.showScreen('decoration');
   *
   * // Here screen was shown
   * await screen?.waitForHide();
   * // Here screen was closed
   */
  public waitForHide() {
    return new Promise((resolve) => this.once('ScreenHidden', resolve));
  }
}
